import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const TipificacionCard = ({ tipificacion }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>{tipificacion.tipificacion}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {tipificacion.child && tipificacion.child.map(childTipificacion => (
            <TipificacionCard key={childTipificacion.id} tipificacion={childTipificacion} />
          ))}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const TipificacionFlow = ({ data }) => {
  // Filtrar las tipificaciones que son padres (padre === null)
  const rootTipificaciones = data.filter(tipificacion => tipificacion.padre === null);

  return (
    <div className="tipificacion-flow">
      {rootTipificaciones.map(rootTipificacion => (
        <TipificacionCard key={rootTipificacion.id} tipificacion={rootTipificacion} />
      ))}
    </div>
  );
};

export default TipificacionFlow;
